module.exports = __webpack_public_path__ + "img/7_64.9811a59d.png";